(() => {
  const normalize = value => value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const text = element => normalize(element.textContent || '');
  const startPattern = /^(?:[^a-z0-9]*)(?:gather your |the )?(?:[a-z -]{0,45} )?ingredients(?: you will need)?\s*[:：]?$/i;
  const endPattern = /^(?:[^a-z0-9]*)(?:cooking )?(?:instructions?|directions?|preparations?|method|tips|grilling|steps|process|how to make it)(?:\s*[:：]?\s*(?:step\s*1|marinade\/sauce|sauce))?\s*[:：]?$/i;
  const starts = {
    'red-white-and-blue-berry-habanero-burgers': 'Red, White and BLUE-berry Habanero Burgers:',
    'healthy-chicken-parm': 'HEALTHY CHICKEN PARM:',
    'keto-pineapple-salsa-burgers': 'Burgers:',
    'rotisserie-brown-sugar-cinnamon-pineapple': 'PREPARATIONS:'
  };
  const knownGroups = new Set(['Bourbon Bacon BBQ sauce','BLUEBERRY HABANERO SALSA:','CHEESE SAUCE','Lemon Garlic Parsley Sauce','Pineapple Habanero Salsa:','Burgers:','Bottom of the Pan','Filling','Batter','Hangrier Sauce'].map(v=>v.toLowerCase()));
  const isGroup = value => value.length < 100 && (/^(?:for the |for |optional sides|optional garnish)/i.test(value) || knownGroups.has(value.toLowerCase()));
  function enhance(root) {
    if (root.dataset.ingredientsReady) return;
    root.dataset.ingredientsReady = 'true';
    const special = starts[(root.dataset.mbxLegacyRecipe || '').split('/').pop()];
    for (const paragraph of Array.from(root.querySelectorAll('p'))) {
      if (!paragraph.querySelector('br') || paragraph.querySelector('iframe,video')) continue;
      const firstLine = normalize(paragraph.innerHTML.split(/<br\b[^>]*>/i)[0].replace(/<[^>]*>/g,'').replace(/&(?:nbsp|#160|#xA0);/gi,' '));
      if (!startPattern.test(firstLine) && !isGroup(firstLine) && !(special && firstLine.toLowerCase() === special.toLowerCase())) continue;
      const container = document.createElement('div');
      let line = document.createElement('div');
      container.appendChild(line);
      const walk = (node, ancestors = []) => {
        if (node.nodeType === 1 && node.tagName === 'BR') { line = document.createElement('div'); container.appendChild(line); return; }
        if (node.nodeType === 3 || (node.nodeType === 1 && node.tagName === 'IMG')) {
          let parent = line;
          for (const ancestor of ancestors) { const copy = ancestor.cloneNode(false); parent.appendChild(copy); parent = copy; }
          parent.appendChild(node.cloneNode(true));
        } else for (const child of Array.from(node.childNodes)) walk(child, node === paragraph ? ancestors : [...ancestors, node]);
      };
      walk(paragraph);
      paragraph.replaceWith(container);
    }
    const elements = Array.from(root.querySelectorAll('*'));
    let active = false;
    let started = false;
    for (const element of elements) {
      if (/^(SCRIPT|STYLE|IMG|IFRAME|VIDEO|TABLE|TBODY|TR)$/.test(element.tagName)) continue;
      const value = text(element);
      if (!value || value.length > 600) continue;
      const hasBlocks = element.querySelector('p,ul,ol,li,h1,h2,h3,h4,h5,h6,table');
      const isStart = startPattern.test(value) || (special && value.toLowerCase() === special.toLowerCase());
      if (isStart && !hasBlocks && !element.closest('.mbx-legacy-ingredient-heading,.mbx-legacy-ingredient-group')) {
        element.classList.add(started ? 'mbx-legacy-ingredient-group' : 'mbx-legacy-ingredient-heading');
        active = true;
        started = true;
        continue;
      }
      if (element.closest('.mbx-legacy-ingredient-heading,.mbx-legacy-ingredient-group')) continue;
      if (active && !hasBlocks && /^(?:large cooking space|this portable griddle|preheat your|a versatile cooking|how to make it)/i.test(value)) active = false;
      if (active && /\bcollection\s*$/i.test(value) && element.querySelector('a')) active = false;
      if (active && !hasBlocks && (endPattern.test(value) || /^instuctions\s*:/i.test(value) || /^1[.)）]\s*(?:to make|heat|preheat|combine|mix|place|prepare|cut|add|cook|remove|season|mash|dip|pour|spread|take|put)/i.test(value))) active = false;
      if (active && !hasBlocks && /^(STRONG|B)$/.test(element.tagName) && isGroup(value)) { element.classList.add('mbx-legacy-ingredient-group'); continue; }
      if (!active || hasBlocks || element.querySelector('img,iframe,video') || !/^(P|LI|DIV|H[1-6])$/.test(element.tagName)) continue;
      element.classList.add(isGroup(value) ? 'mbx-legacy-ingredient-group' : 'mbx-legacy-ingredient-item');
    }
    const eligible = element => !element.querySelector('img,video,iframe,table') && (element.matches('.mbx-legacy-ingredient-item,.mbx-legacy-ingredient-group') || (/^(UL|OL)$/.test(element.tagName) && element.querySelector('.mbx-legacy-ingredient-item')));
    for (const parent of [root, ...root.querySelectorAll('div')]) {
      if (parent.closest('.mbx-legacy-ingredient-scroll')) continue;
      let wrapper;
      for (const child of Array.from(parent.childNodes)) {
        if (child.nodeType === 3 && !child.textContent.trim()) continue;
        if (child.nodeType === 1 && (eligible(child) || (wrapper && child.tagName === 'BR'))) {
          if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.className = 'mbx-legacy-ingredient-scroll';
            wrapper.tabIndex = 0;
            wrapper.setAttribute('role', 'region');
            wrapper.setAttribute('aria-label', 'Ingredients');
            parent.insertBefore(wrapper, child);
          }
          wrapper.appendChild(child);
        } else wrapper = null;
      }
    }
  }
  const run = () => document.querySelectorAll('[data-mbx-legacy-recipe]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();
